<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Update LogIn Page UI Configuration</h4>
  <i class="bi bi-x-lg text-danger" style="font-size:larger" (click)="onClose()"></i>
</div>

<div class="modal-body text-grey">
  <form spellcheck="false" autocomplete="off" [formGroup]="logInUiDetails" (ngSubmit)="updateLogInUiConfigurationValue(logInUiDetails)">
    <mat-form-field style="width: 100%;">
      <mat-label>Configure LogIn Page UI</mat-label>
      <mat-select formControlName="configureLogInPage" style="font-size: revert;">
        <mat-option value=true>True</mat-option>
        <mat-option value=false>False</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%;">
      <mat-label>Title</mat-label>
      <textarea formControlName="title" matInput style="font-size: revert;"></textarea>
    </mat-form-field>

    <mat-form-field style="width: 100%;">
      <mat-label>Logo And Title</mat-label>
      <textarea formControlName="logoAndTitle" matInput style="font-size: revert;"></textarea>
    </mat-form-field>

  </form>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary"
            (click)="updateLogInUiConfigurationValue(logInUiDetails)">
      Submit
    </button>
  </div>
</div>
